<template>
  <div 
    :class="baseTextareaClasses" 
    class="base-textarea"
  >
    <textarea
      :placeholder="placeholder"
      :value="value"
      :disabled="isDisabled"
      @focus="$emit('focus', $event.target.value)"
      @blur="$emit('blur', $event.target.value)"
      @input="$emit('input', $event.target.value)"
      @change="$emit('change', $event.target.value)"
      @click="$emit('click')"
    />
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
};
</script>

<script setup>
import { computed } from "vue";

const props = defineProps({
  value: {
    type: [String, Number, Date],
    default: "",
  },
  variation: {
    type: String,
    default: "",
    validator(value) {
      return ["", "fill-height"].includes(value);
    },
  },
  cap: {
    type: [String, Array],
    default: "",
    validator: function (value) {
      const validTypes = [
        "",
        "top",
        "right",
        "bottom",
        "left",
        "top-left",
        "top-right",
        "bottom-right",
        "bottom-left",
      ];

      if (Array.isArray(value)) {
        return value.every((type) => validTypes.includes(type));
      } else {
        return validTypes.includes(value);
      }
    },
  },
  label: {
    type: String,
    default: "",
  },
  placeholder: {
    type: String,
    default: "",
  },
  isDisabled: {
    type: Boolean,
    default: false,
  },
  isFullWidth: {
    type: Boolean,
    default: false,
  },
});

defineEmits(["focus", "blur", "input", "change", "click"]);

const baseTextareaClasses = computed(() => ({
  [`base-textarea--variation-${props.variation}`]: true,
  ...(Array.isArray(props.cap)
    ? props.cap.reduce(
        (acc, c) => ({ ...acc, [`base-textarea--cap-${c}`]: true }),
        {}
      )
    : { [`base-textarea--cap-${props.cap}`]: true }),
  "base-textarea--is-full-width": props.isFullWidth,
}));
</script>

<style lang="scss" scoped>
@import "./base-textarea.scss";
</style>
